import debounce from "lodash/debounce";
import template from "lodash/template";
import Notify from "./notify";
import { formatBytes } from "./helpers";
const scrollbarWidth = require("scrollbarwidth");

let req = null;
let loading = false;
let meta = null;
let results = [];
let query = "";
let page = 1;
let ps = null;

const formatType = (type) => {
    const dictionary = {
        material: "материал",
        system: "система",
    };
    return dictionary[type];
};

const formatFolderLink = (folder) => {
    if (folder.documents.length === 1) {
        return folder.documents[0].file.link;
    }
    return `https://nitero.ru/${folder.type}s/${folder.id}/documents`;
};

window.popupDocsHelpers = { formatBytes, formatType, formatFolderLink };

const tmpl = template(`
    <% results.forEach(function(folder) { %>
        <li class="acc_section">
            <div class="acc_head"><%- folder.name %><i></i></div>
            <div class="acc_content" style="display: none">
                <div class="popup-docs__list__body">
                    <div class="files">
                        <% folder.documents.forEach(function(document) { %>
                            <div class="files__item">
                                <svg class="icon">
                                    <use xlink:href="/img/default/sprite.svg#doc"></use>
                                </svg>
                                <div class="files__name">
                                    <a href="<%- document.file.link %>" target="_blank">
                                        <%- document.file.as %>
                                    </a>
                                </div>
                                <div class="files__size"><%- popupDocsHelpers.formatBytes(document.file.size) %></div>
                            </div>
                        <% }); %>
                        
                    </div>
                </div>
            </div>
            <div class="popup-docs__list__ctrl">
                <a href="<%- popupDocsHelpers.formatFolderLink(folder) %>" target="_blank" class="popup-docs__btn-download">
                    <svg class="icon">
                        <use xlink:href="/img/default/sprite.svg#download"></use>
                    </svg>
                </a>
                <div class="popup-docs__tag <%- folder.type === 'system' ? 'popup-docs__tag--system' : '' %>">
                    <%- popupDocsHelpers.formatType(folder.type) %>
                </div>
            </div>
        </li>
    <% }); %>
    <%- query.length !== 0 && results.length === 0 ? 'Не найдено': '' %>
`);

const handleInputKeyup = (e) => {
    query = $(e.currentTarget).val().trim();

    resetState();

    fetchResults();
};

const resetState = () => {
    req = null;
    loading = false;
    meta = null;
    results = [];
    page = 1;
};

const fetchResults = () => {
    if (loading) return;

    if (req) {
        req.abort();
    }

    loading = true;
    renderLoading();

    req = $.ajax({
        method: "GET",
        data: { filter: { query }, page },
        url: "https://nitero.ru/api/v1/documents",
    })
        .done((data) => {
            meta = data.meta;
            results = [...results, ...data.data];
            renderResults();
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            if (errorThrown === "abort") return;
            const message = errorThrown ? errorThrown : "Произошла ошибка";
            Notify.error(message);
        })
        .always(() => {
            loading = false;
            renderLoading();
        });
};

const renderLoading = () => {
    $("#popup-docs__input")
        .parent()
        .toggleClass("loading", loading && page === 1);

    $("#popup-docs__loader").toggleClass("active", loading && page > 1);
};

const renderResults = () => {
    const html = tmpl({
        results,
        query,
    });
    $("#popup-docs__list").html(html);
    if (ps) {
        ps.update();
    }
};

const initObserver = () => {
    const options = {
        root: $("#popup-docs__window")[0],
        rootMargin: "0px",
        threshold: 1.0,
    };

    const callback = (entries, observer) => {
        if (entries[0].isIntersecting) {
            if (meta?.current_page < meta?.last_page) {
                page++;
                fetchResults();
            }
        }
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe($("#popup-docs__end")[0]);
};

const handleOpenBtn = (e) => {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const src = $button.attr("href");
    const type = $button.data("type") || "inline";
    const removalDelay = $button.data("effect") ? 500 : 0;
    const effect = $button.data("effect") || "";

    $.magnificPopup.open({
        items: {
            src,
            type,
            closeBtnInside: true,
        },
        mainClass: effect,
        removalDelay,
    });

    fetchResults();
};

$(function () {
    if ($("#popup-docs").length === 0) return;

    if (scrollbarWidth() >= 15) {
        ps = new PerfectScrollbar("#popup-docs__window");
    }

    initObserver();

    $(".popup-docs").on(
        "keyup",
        "#popup-docs__input",
        debounce(handleInputKeyup, 200)
    );

    $(".js-popup-docs-open").on("click", handleOpenBtn);
});
